import { Button } from '@crazyegginc/hatch';

import { SupportLinks } from '/src/support';
import { Panel, IntroText } from '../SsoUi';
import { SupportLink } from '/src/features/_global/components/SupportLink';

export function UpgradePrompt() {
  return (
    <Panel>
      <IntroText className="mb-7" />
      <Button component={SupportLink} href={SupportLinks.general.newSupportRequest} className="self-start">
        Contact sales
      </Button>
    </Panel>
  );
}
